




























import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import appStore from '@/core/app/app.store';
import { BreadcrumbItem } from '@/types/contentServerContract';
import breakpointsState from '@/core/responsive/breakpoints/breakpointsState.observable';

@Component
export default class Breadcrumb extends Vue {
    $refs!: Vue['$refs'] & {
        breadcrumbsContainer: Vue
    };

    get inPhoneViewport(): boolean {
        return breakpointsState.isBreakpointActive('max-sm');
    }

    get breadcrumbs(): BreadcrumbItem[] {
        const crumbs = appStore?.breadcrumbPrettified ? [...appStore.breadcrumbPrettified] : [];
        return crumbs;
    }

    get showBreadcrumb(): boolean {
        // Hide in tunnelview
        if (this.hideBreadcrumb) return false;

        // Hide when frontpage
        return this.$route.path !== '/';
    }

    get hideBreadcrumb(): boolean {
        return appStore.hideBreadcrumb;
    }

    mounted(): void {
        this.scrollBreadcrumbsOnDemand();
    }

    @Watch('breadcrumbs')
    private breadcrumbsChanged(): void {
        this.scrollBreadcrumbsOnDemand();
    }

    @Watch('inPhoneViewport')
    private scrollBreadcrumbsOnDemand(): void {
        if (this.inPhoneViewport && this.$refs.breadcrumbsContainer) {
            this.$nextTick(() => {
                const $ul = this.$refs.breadcrumbsContainer.$el;

                if ($ul) {
                    $ul.scrollTo($ul.scrollWidth, 0);
                }
            });
        }
    }
}
